import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneWaveOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.442 3.955c.448-.64 1.223-1.289 2.522-1.817l2.57 3.691-.91 2.129c-.399.933-.46 2.127.176 3.184.477.794 1.32 1.985 2.709 3.374 1.382 1.382 2.569 2.222 3.363 2.7 1.069.644 2.278.576 3.218.165l2.088-.914 3.683 2.561c-.529 1.298-1.178 2.075-1.818 2.525-.795.559-1.8.771-3.078.577-2.682-.407-6.096-2.55-9.31-5.763S2.285 9.732 1.871 7.04c-.197-1.282.013-2.29.57-3.085M5.67 0l3.91 5.62-1.3 3.045c-.217.506-.221 1.078.063 1.55.404.673 1.157 1.747 2.438 3.028 1.275 1.275 2.346 2.026 3.02 2.432.477.287 1.056.28 1.567.057l3.01-1.318L24 18.324c-2.605 9.193-11.002 5.93-17.618-.684C-.235 11.027-3.534 2.598 5.67 0M14.9.353a12.02 12.02 0 0 1 8.746 8.746l-1.777.317a10.22 10.22 0 0 0-7.286-7.286zm4.902 9.432a7.51 7.51 0 0 0-5.588-5.588l-.317 1.776a5.71 5.71 0 0 1 4.13 4.13z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneWaveOutlinedSize24Glyph.displayName = 'PhoneWaveOutlinedSize24Glyph';
